app.service("TestSupportAPI", [
	"$http",
	"ENV",
	"Session",
	"$q",
	function ($http, ENV, Session, $q) {
		const baseUri = ENV.API + "/api/test-support";

		/**
		 * Generates the common headers required for API authentication and context.
		 * @returns {Object} The headers object.
		 */
		const getHeaders = function () {
			return {
				Authorization: "Bearer " + Session.token,
			};
		};

		/**
		 * Every call here hard deletes clinical data. Refused outright anywhere test data is not enabled
		 * (localhost and dev only), so a stray call can never reach a production record.
		 */
		const send = function (config) {
			if (!ENV.TEST_DATA_ENABLED) {
				return $q.reject({ status: 403, data: { message: "Test support is not available in this environment" } });
			}
			return $http(config);
		};

		var service = {

			// =================================================================
			// Patient Deletion (Root)
			// =================================================================

			/**
			 * Hard deletes a patient and all their associated data.
			 * Restricted to ADMIN role only.
			 * @param {integer} patientId - The patient's unique identifier.
			 */
			deletePatient: function (patientId) {
				return send({
					method: "DELETE",
					url: `${baseUri}/patient/${patientId}`,
					headers: getHeaders(),
				});
			},

			// =================================================================
			// Clinical Notes
			// =================================================================

			/**
			 * Hard deletes a specific progress note.
			 * Restricted to ADMIN role only.
			 * @param {integer} patientId - The patient's unique identifier.
			 * @param {string} progressNoteId - The unique identifier of the progress note.
			 */
			deleteProgressNote: function (patientId, progressNoteId) {
				return send({
					method: "DELETE",
					url: `${baseUri}/patient/${patientId}/progress-note/${progressNoteId}`,
					headers: getHeaders(),
				});
			},

			/**
			 * Hard deletes a specific operation note.
			 * Restricted to ADMIN role only.
			 * @param {integer} patientId - The patient's unique identifier.
			 * @param {string} operationNoteId - The unique identifier of the operation note.
			 */
			deleteOperationNote: function (patientId, operationNoteId) {
				return send({
					method: "DELETE",
					url: `${baseUri}/patient/${patientId}/operation-note/${operationNoteId}`,
					headers: getHeaders(),
				});
			},

			// =================================================================
			// Referrals
			// =================================================================

			/**
			 * Hard deletes a referral. Handles both numeric IDs (Cataract) and UUIDs (V2).
			 * Restricted to ADMIN role only.
			 * @param {integer} patientId - The patient's unique identifier.
			 * @param {string|integer} referralId - The unique identifier of the referral.
			 */
			deleteReferral: function (patientId, referralId) {
				return send({
					method: "DELETE",
					url: `${baseUri}/patient/${patientId}/referral/${referralId}`,
					headers: getHeaders(),
				});
			},

			// =================================================================
			// Surgery Workups
			// =================================================================

			/**
			 * Hard deletes a surgery workup.
			 * Restricted to ADMIN role only.
			 * @param {integer} patientId - The patient's unique identifier.
			 * @param {string} surgeryWorkupId - The unique identifier of the surgery workup.
			 */
			deleteSurgeryWorkup: function (patientId, surgeryWorkupId) {
				return send({
					method: "DELETE",
					url: `${baseUri}/patient/${patientId}/surgery-workup/${surgeryWorkupId}`,
					headers: getHeaders(),
				});
			},

			// =================================================================
			// Vision Records
			// =================================================================

			/**
			 * Hard deletes a patient vision record.
			 * Restricted to ADMIN role only.
			 * @param {integer} patientId - The patient's unique identifier.
			 * @param {string} patientVisionId - The unique identifier of the patient vision record.
			 */
			deleteVision: function (patientId, patientVisionId) {
				return send({
					method: "DELETE",
					url: `${baseUri}/patient/${patientId}/vision/${patientVisionId}`,
					headers: getHeaders(),
				});
			},
		};

		return service;
	},
]);